module.exports = __webpack_public_path__ + "img/Cutaways_house_4.bf8835b4.jpg";